<template>
  <div class="content">
    <form>
    <conversion-form :datas="dataall"></conversion-form>
    <sklad :datas="dataall"></sklad>
    <paytype :datas="dataall"></paytype>
    <asos :datas="dataall"></asos>
    <kontragent :datas="dataall"></kontragent>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.convertion.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import ConversionForm from "./Form.vue"
import {Sklad, Paytype, Asos, Kontragent } from "@/pages";
export default {
  components: { ConversionForm, Sklad, Paytype, Asos, Kontragent },
  data() {
    return {
      dataall: {
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at:0,
        pay_type_from_id:1,
        pay_type_of_id:3,
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        summa: 0,
        summa_convertion: 0,
        dollar_rate:0,
        number:0,
        comment:"",
      }
    };
  },
  created:function(){
    let self=this;
    axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Конверсия" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
